const STORAGE_KEY = "compare_ids";
export const MAX_COMPARE = 3;

export function getCompareIds() {
    try {
        const ids = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
        return Array.isArray(ids) ? ids.slice(0, MAX_COMPARE) : [];
    } catch {
        return [];
    }
}

export function setCompareIds(ids) {
    const next = ids.slice(0, MAX_COMPARE);
    localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    window.dispatchEvent(new Event("compare-updated"));
    return next;
}

export function addToCompare(id) {
    const ids = getCompareIds();
    if (ids.includes(id)) {
        return { added: false, ids, full: ids.length >= MAX_COMPARE };
    }
    if (ids.length >= MAX_COMPARE) {
        return { added: false, ids, full: true };
    }
    return { added: true, ids: setCompareIds([...ids, id]), full: false };
}

export function removeFromCompare(id) {
    return setCompareIds(getCompareIds().filter((x) => x !== id));
}

export function clearCompare() {
    return setCompareIds([]);
}

export function compareUrl(ids = getCompareIds()) {
    if (!ids.length) return "/compare";
    return `/compare?ids=${ids.join(",")}`;
}
